const RatingStars = ({
  rating,
  totalReviews = 0,
  showCount = true,
  size = "sm",         // sm | md | lg | xl
  alt = false,         // stacked layout
  align = "center",    // text alignment: left | center | right
  starClass = "",      // ✅ custom classes for all star icons
  ratingClass = "",    // ✅ custom classes for rating number
  countClass = "",     // ✅ custom classes for review count
}) => {
  // Tailwind size map
  const sizeMap = {
    sm: { star: "text-sm", text: "text-xs", count: "text-[10px]", gap: "gap-1.5" },
    md: { star: "text-base", text: "text-sm", count: "text-xs", gap: "gap-2" },
    lg: { star: "text-lg", text: "text-base", count: "text-sm", gap: "gap-2" },
    xl: { star: "text-2xl", text: "text-lg", count: "text-base", gap: "gap-2" },
  };
  const s = sizeMap[size] || sizeMap.sm;

  // Percentage for filled stars
  const percent = Math.min(Math.max(rating / 5, 0), 1) * 100;

  // Alignment map
  const alignMap = {
    left: "items-start text-left",
    center: "items-center text-center",
    right: "items-end text-right",
  };
  const alignClass = alignMap[align] || alignMap.center;

  // Shared Stars JSX
  const Stars = () => (
    <div className="relative flex">
      {/* Empty outline stars */}
      {[...Array(5)].map((_, i) => (
        <i
          key={`empty-${i}`}
          className={`fa-regular fa-star text-amber-400 ${s.star} ${starClass}`}
        />
      ))}
      {/* Filled overlay stars */}
      <div
        className="absolute top-0 left-0 overflow-hidden flex"
        style={{ width: `${percent}%` }}
      >
        {[...Array(5)].map((_, i) => (
          <i
            key={`full-${i}`}
            className={`fa-solid fa-star text-amber-400 ${s.star} ${starClass}`}
          />
        ))}
      </div>
    </div>
  );

  if (alt) {
    // Alternate stacked layout
    return (
      <div className={`flex flex-col ${alignClass} ${s.gap}`}>
        <Stars />
        <div className="flex items-center gap-1">
          <span
            className={`font-semibold text-gray-800 ${s.text} ${ratingClass}`}
          >
            {rating.toFixed(2)}
          </span>
          {showCount && totalReviews > 0 && (
            <span className={`text-gray-500 ${s.count} ${countClass}`}>
              ({totalReviews.toLocaleString()}{" "}
              {totalReviews === 1 ? "review" : "reviews"})
            </span>
          )}
        </div>
      </div>
    );
  }

  // Default horizontal layout
  return (
    <div className={`flex items-center ${s.gap}`}>
      <Stars />
      <div className="flex items-center gap-1">
        <span
          className={`font-semibold text-gray-800 ${s.text} ${ratingClass}`}
        >
          {rating.toFixed(2)}
        </span>
        {showCount && totalReviews > 0 && (
          <span className={`text-gray-500 ${s.count} ${countClass}`}>
            ({totalReviews.toLocaleString()}{" "}
            {totalReviews === 1 ? "review" : "reviews"})
          </span>
        )}
      </div>
    </div>
  );
};

export default RatingStars;
